import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Note: StrictMode disabled to prevent double-render conflicts with vanilla JS trading script
root.render(<App />);

reportWebVitals();
